/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Map from 'scripts/models/base/map';
import List from 'scripts/models/base/list';
import ImageCloudinary from 'scripts/models/api/image/cloudinary';
import Hole from 'scripts/models/api/hole/hole';
import Player from 'scripts/models/api/player/player';

let Holes = List.extend(
    {
        Map: Hole,
    },
    {},
);

let Players = List.extend(
    {
        Map: Player,
    },
    {},
);

let Event = Map.extend({
    define: {
        state: {
            type: 'string',
        },
        name: {
            type: 'string',
        },
        shortName: {
            type: 'string',
        },
        url: {
            type: 'string',
        },
        startTime: {
            type: 'string',
        },
        endTime: {
            type: 'string',
        },
        image: {
            Type: ImageCloudinary,
            Value: '*',
        },
        holes: {
            Type: Holes,
            Value: '*',
        },
        players: {
            Type: Players,
            Value: '*',
        },
    },
});

let EventsList = List.extend(
    {
        Map: Event,
    },
    {},
);

export { Event, EventsList };
